import React, { useEffect, useMemo, useState } from "react";
import ModalContent from "src/Shared/Components/ModalContent/ModalContent";
import { VIEW_MODE } from "src/Shared/Enums/ViewMode.enum";
import { ILeadTypeSetting } from "../../Interfaces/ILeadTypeSetting";
import { getFormValidation } from "src/Shared/Components";
import { fields } from "./fields";
import { Box } from "@mui/material";
import ViewInputControl from "src/Shared/Components/ViewInputControl/ViewInputControl";
import { EDITOR_TYPES } from "src/Shared/Enums";
import SettingsService from "../../Services/Settings.service";
import { finalize } from "rxjs";
import { ToastService } from "src/Shared/Services";
import { AxiosError } from "axios";
import { useModal, useStore } from "src/Shared/Hooks";
import { observer } from "mobx-react";

type Props = {
  mode: VIEW_MODE;
  leadType?: ILeadTypeSetting;
};
const AddOrEditLeadType: React.FC<Props> = ({ mode, leadType }) => {
  const leadTypeForm = useMemo(() => getFormValidation(fields), []);
  const getField = (key: string) => leadTypeForm.$(key);
  const [loading, setLoading] = useState<boolean>(false);
  const {
    rootStore: {
      settingsStore: { getLeadTypes },
    },
  } = useStore();

  const { close } = useModal();

  useEffect(() => {
    if (mode == VIEW_MODE.EDIT) {
      leadTypeForm.set(leadType);
    }
  }, []);

  const onConfirm = () => {
    let request: ILeadTypeSetting = {
      leadTypeID: 0,
      leadTypeName: getField("leadTypeName").value,
      isActive: true,
    };
    if (mode == VIEW_MODE.EDIT) {
      request.leadTypeID = leadType.leadTypeID;
      request.isActive = leadType.isActive;
    }
    setLoading(true);

    SettingsService.addOrUpdateLeadType(request)
      .pipe(
        finalize(() => {
          setLoading(false);
        }),
      )
      .subscribe({
        next: (data: string) => {
          ToastService.success(data);
          getLeadTypes();
          close();
        },
        error: (error: AxiosError) => ToastService.axiosError(error),
      });
  };
  return (
    <ModalContent
      maxWidth="xs"
      title={mode == VIEW_MODE.ADD ? "Add Lead Type" : "Edit Lead Type"}
      buttonText="Save"
      onSaveButtonClick={() => onConfirm()}
      onCancel={() => {
        close();
      }}
      cancelButton={true}
      btnLoading={loading}
    >
      <Box sx={{ mt: 2 }}>
        <ViewInputControl
          type={EDITOR_TYPES.TEXT_FIELD}
          form={leadTypeForm}
          field={getField("leadTypeName")}
        />
      </Box>
    </ModalContent>
  );
};

export default observer(AddOrEditLeadType);
